const SmsVectorIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7 13.3L13.3 10.7C13.4833 10.5167 13.575 10.2833 13.575 10C13.575 9.71667 13.4833 9.48333 13.3 9.3L10.675 6.675C10.4917 6.49167 10.2627 6.404 9.988 6.412C9.71267 6.42067 9.48333 6.51667 9.3 6.7C9.11667 6.88333 9.025 7.11667 9.025 7.4C9.025 7.68333 9.11667 7.91667 9.3 8.1L10.2 9H6.975C6.69167 9 6.45833 9.09567 6.275 9.287C6.09167 9.479 6 9.71667 6 10C6 10.2833 6.096 10.5207 6.288 10.712C6.47933 10.904 6.71667 11 7 11H10.2L9.275 11.925C9.09167 12.1083 9.004 12.3377 9.012 12.613C9.02067 12.8877 9.11667 13.1167 9.3 13.3C9.48333 13.4833 9.71667 13.575 10 13.575C10.2833 13.575 10.5167 13.4833 10.7 13.3ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0 12.6833 0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025 17.075 2.925C17.975 3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20Z"
        fill="white"
      />
    </svg>
  );
};

export default SmsVectorIcon;
